import path from "path";
import folder from "../common/folder";

function getTree(folder: folder, rootDir: string, allFolders: folder[]) {
	let tree: string[] = [];
	function loopThrough(fold: folder) {
		const parent = allFolders.filter(
			(e) => e.folder_uid === fold.parent_folder
		);
		if (parent.length === 0 || fold.folder_uid === rootDir) {
			return;
		} else {
			tree.push(path.join(parent[0].title));
			loopThrough(parent[0]);
		}
	}
	loopThrough(folder);
	return tree.reverse().join('/');
}

export default getTree